<template>
  <div class="login">

    <div class="title">
      <div class="logo">
        <img src="@/assets/login/logo.png" class="img" />
      </div>
      <div class="title_text">
        v1.0.1
      </div>
      <ul class="contact">
        <li>客服热线 </li>
        <li>400-180-2128</li>
      </ul>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {


  }
}
</script>

<style lang="less" scoped>
.login {
  width: 80%;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;

  .title {
    margin-top: 40px;
    text-align: center;

    .logo {
      display: inline-block;
      background-color: rgba(255, 255, 255, 1);
      text-align: center;
      font-family: Roboto;
      border: 4px solid rgba(43, 70, 138, 1);
      padding: 10px;
      width: 100px;
      height: 100px;
      border-radius: 50%;
      position: relative;

      .img {
        width: 63px;
        height: 55.83px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .title_text {
      margin: 10px 0;
      color: rgb(16, 16, 16);
      font-size: 0.16rem;
      text-align: center;
    }

    .contact {
      display: flex;
      justify-content: space-between;
      padding-bottom: 10px;
      border-bottom: 1px solid #e5e5e5;
    }
  }




}
</style>